import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as l, normalizeClass as d, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const n = {
  name: "DtIconHourglass",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ s("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.5 10.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1H9V8.914a1.5 1.5 0 0 0-.44-1.06L6.707 6l1.854-1.853A1.5 1.5 0 0 0 9 3.086V1.5h.5a.5.5 0 0 0 0-1h-7a.5.5 0 0 0 0 1H3v1.586c0 .398.158.78.44 1.06L5.292 6 3.439 7.853A1.5 1.5 0 0 0 3 8.914V10.5h-.5ZM4 3.086a.5.5 0 0 0 .146.353L6 5.293l1.853-1.854A.5.5 0 0 0 8 3.086V1.5H4v1.586ZM7.854 8.56A.5.5 0 0 1 8 8.914V10.5H4V8.914a.5.5 0 0 1 .147-.353L6 6.707l1.854 1.854Z",
  fill: "currentColor"
}, null, -1), u = [
  _
];
function h(e, m, r, f, p, a) {
  return l(), i("svg", {
    "aria-label": r.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--hourglass"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Hourglass",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, u, 10, c);
}
const b = /* @__PURE__ */ o(n, [["render", h]]);
export {
  b as default
};
//# sourceMappingURL=hourglass.js.map
